import { createQueryKeys } from '@lukemorales/query-key-factory';
import { IS_ADMIN_FE } from 'common/constants/general-access-role.constants';
import { EQueryKeys } from 'common/enums/query-kyes.enum';
import { getAssetsListAdminService, getAssetsListService } from '../services/assets.service';
import { TAdminAssetsListReqParams, TAssetsListResData } from '../types/assets.types';

export const assetsQueryKeys = createQueryKeys(EQueryKeys.AssetQueryKeys, {
  getAssetsList_MultiRole: (counterpartyGUID: string, params?: TAdminAssetsListReqParams) => ({
    queryKey: ['acc-mng-assets-list-all', params, counterpartyGUID],
    queryFn: (): Promise<TAssetsListResData> =>
      IS_ADMIN_FE ? getAssetsListAdminService(params) : getAssetsListService(counterpartyGUID, params),
  }),

  getAssetsListAdmin: (params?: TAdminAssetsListReqParams) => ({
    queryKey: ['acc-mng-assets-admin-list-all', params],
    queryFn: (): Promise<TAssetsListResData> => getAssetsListAdminService(params),
  }),
});
